import PropTypes from 'prop-types'
import React from 'react'

import { Tooltip } from 'react-wot-bootstrap'

const WizardDefaultTooltip = (props) => {
    return (
        <Tooltip id={props.tooltipId}>
            {props.children}
        </Tooltip>
    )
}

WizardDefaultTooltip.propTypes = {
    tooltipId: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
}

export default WizardDefaultTooltip



// WEBPACK FOOTER //
// ./components/BattleWizard/components/WizardDefaultTooltip/WizardDefaultTooltip.jsx